export default __webpack_public_path__ + "c0def9dda0c20a4e8b7c6704de967e70.svg";